import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaImageTone } from '../../../preview-common/meta-image-tone';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Facebook Reels: the creative full screen, with the page, one line of copy
 * and a button tinted with the creative's own colour laid over its foot.
 */
@Component({
  selector: 'app-meta-facebook-reels',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-reels.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './facebook-reels.component.scss',
  ]
})
export class MetaFacebookReelsPreviewComponent implements OnChanges {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  buttonTone = MetaImageTone.FALLBACK;
  private toneSource: string | null = null;

  ngOnChanges(): void {
    const creative = this.data?.creative ?? '';
    if (creative === this.toneSource) {
      return;
    }
    this.toneSource = creative;
    MetaImageTone.measure(creative, this.data?.creativeKind).then((tone) => {
      if (this.toneSource === creative) {
        this.buttonTone = tone;
      }
    });
  }

  /** One short line before "...more": the first paragraph, cut on a word at 24 characters. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 24);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
